import { render, html, TemplateResult } from "lit-html";
import { Component } from "@kluntje/core";
import CookieService from "Services/CookieService";

/**
 * Custom Element to render dynamically correct back button
 */
class FRABackButton extends Component {
  static readonly COOKIE_BACK_HREF = "rh-back-href";
  static readonly COOKIE_BACK_LABEL = "rh-back-label";
  static readonly ATTRIBUTE_MAPPINGS = "mappings";
  static readonly ATTRIBUTE_LANG = "lang";
  static readonly ATTRIBUTE_DEFAULT_HREF = "default-href";
  static readonly ATTRIBUTE_DEFAULT_LABEL = "default-label";

  constructor() {
    super({
      ui: {
        label: ".fra-e-link__label",
        anchor: ".fra-e-back-button",
      },
    });
  }

  get lang(): string {
    return this.getAttribute(FRABackButton.ATTRIBUTE_LANG) || "";
  }

  get defaultHref(): string {
    return this.getAttribute(FRABackButton.ATTRIBUTE_DEFAULT_HREF) || "";
  }

  get defaultLabel(): string {
    return this.getAttribute(FRABackButton.ATTRIBUTE_DEFAULT_LABEL) || "";
  }

  get mappings(): string {
    return this.getAttribute(FRABackButton.ATTRIBUTE_MAPPINGS) || "";
  }

  /**
   * @override
   */
  afterComponentRender() {
    let referrer = document.referrer;

    const lang = this.lang;

    const COOKIE_NAME_HREF = `${lang}_${FRABackButton.COOKIE_BACK_HREF}`;
    const COOKIE_NAME_LABEL = `${lang}_${FRABackButton.COOKIE_BACK_LABEL}`;

    let href = this.defaultHref;
    let label = this.defaultLabel;

    if (referrer) {
      const mappingsJsonStr = this.mappings;
      if (mappingsJsonStr) {
        const mappings = JSON.parse(mappingsJsonStr);
        const referrerUrl = new URL(referrer);
        const referrerUrlHost = referrerUrl.host;

        mappings.forEach((mapping: { domain: string; redirectUrl: string; label: string }) => {
          if (mapping.domain.startsWith(referrerUrlHost)) {
            if (mapping.redirectUrl) {
              referrer = mapping.redirectUrl;
            }
            CookieService.setCookie(COOKIE_NAME_HREF, referrer, 365);
            CookieService.setCookie(COOKIE_NAME_LABEL, mapping.label, 365);
          }
        });
      } else {
        CookieService.removeCookie(COOKIE_NAME_HREF);
        CookieService.removeCookie(COOKIE_NAME_LABEL);
      }
    }

    if (CookieService.isCookieSet(COOKIE_NAME_HREF) && CookieService.isCookieSet(COOKIE_NAME_LABEL)) {
      href = CookieService.getCookie(COOKIE_NAME_HREF) || "";
      label = CookieService.getCookie(COOKIE_NAME_LABEL) || "";
    }

    render(this.buttonMarkup(href, label), this);
  }

  buttonMarkup(href: string, label: string): TemplateResult {
    return html`
      <a href="${href}" class="fra-e-link fra-e-link--with-icon fra-e-link--animated-left">
        <fra-e-icon class="fra-e-icon" icon-id="fra-icon-back"></fra-e-icon>
        <span class="fra-e-link__label">${label}</span>
      </a>
    `;
  }
}

customElements.define("fra-e-back-button", FRABackButton);

export default FRABackButton;
